import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inputGroup" }
const _hoisted_2 = { class: "groupTitle" }
const _hoisted_3 = { class: "inputGroup" }
const _hoisted_4 = { class: "groupTitle" }
const _hoisted_5 = { class: "inputGroup" }
const _hoisted_6 = { class: "groupTitle" }
const _hoisted_7 = { class: "inputGroup" }
const _hoisted_8 = { class: "groupTitle" }
const _hoisted_9 = { class: "inputGroup" }
const _hoisted_10 = { class: "groupTitle" }
const _hoisted_11 = { class: "inputGroup" }
const _hoisted_12 = { class: "groupTitle" }
const _hoisted_13 = { class: "inputGroup" }
const _hoisted_14 = { class: "groupTitle" }
const _hoisted_15 = { class: "groupInputs flex" }
const _hoisted_16 = { class: "groupInputs flex" }
const _hoisted_17 = { class: "inputRow" }
const _hoisted_18 = { class: "flex flex-wrap" }
const _hoisted_19 = ["checked", "id", "value"]
const _hoisted_20 = { class: "inputTitle ml-2" }
const _hoisted_21 = ["for"]
const _hoisted_22 = { class: "inputGroup" }
const _hoisted_23 = { class: "groupTitle" }
const _hoisted_24 = { class: "inputGroup" }
const _hoisted_25 = { class: "groupTitle" }
const _hoisted_26 = { class: "inputGroup" }
const _hoisted_27 = { class: "groupTitle" }

import FilterService from "@/utilities/services/FilterService";
import {ErrorLocationType, TableType} from "@/utilities/enums/Enums";
import {computed, onMounted, ref} from "vue";
import {useGlobalStore} from "@/stores/GlobalStore";
import {AttributeFilter} from "@/models/AttributeFilter";
import {CategoryInfo} from "@/models/category/CategoryInfo";
import {CategoryService} from "@/utilities/services/entities/CategoryService";



export default /*#__PURE__*/_defineComponent({
  __name: 'DisdiFilterPopup',
  setup(__props) {

const globalStore = useGlobalStore();
const categoryService = new CategoryService();

const userFilters = computed(()=>{
  return globalStore.userPreferences.userFilters;
});
const userHiddenColumns = computed(()=>{
  return globalStore.userPreferences.userHiddenColumns;
});


const tmpUserFilters = computed(()=>{
  return globalStore.tmpPreferences.tmpUserFilters;
});
const tmpUserHiddenColumns = computed(()=>{
  return globalStore.tmpPreferences.tmpUserHiddenColumns;
});

const categoryList = ref<Array<CategoryInfo>|null>(null);


// init checkboxes according to tmpFilters [attributeValue == input-id]
const isFiltered = (attName, attVal) => {
  return tmpUserFilters.value.some(tuf => tuf.attributeName === attName && tuf.attributeValue === attVal.toString());
};

// init visibility buttons according to tmpHiddenColumns
const isHidden = (attName) => {
  return tmpUserHiddenColumns.value.some(thc => thc.attributeName === attName.toString());
};

const filterChanged = ({ target }, propName) => {
  if(target.checked) {
    // add to tmpFilterList
    globalStore.addUserFilter(new AttributeFilter(TableType[TableType.disdi], propName, target.value.toString()));
  }
  else {
    // remove from tmpFilterList
    tmpUserFilters.value.forEach((tuf,index)=>{
      if(tuf.attributeName === propName && tuf.attributeValue === target.value.toString()) tmpUserFilters.value.splice(index, 1);
    });

    globalStore.setTmpFilters(tmpUserFilters.value);
  }

  calculateRestEntities();
};


const visibilityChange = (colName) => {
  if(!tmpUserHiddenColumns.value.some(thc => thc.attributeName === colName)) {
    // add to tmpHiddenColumnList
    globalStore.addUserHiddenColumn(new AttributeFilter(TableType[TableType.disdi], colName, ""));
  }
  else {
    // remove from tmpHiddenColumnList
    tmpUserHiddenColumns.value.forEach((thc,index)=>{
      if(thc.attributeName === colName) tmpUserHiddenColumns.value.splice(index, 1);
    });

    globalStore.setTmpHiddenColumns(tmpUserHiddenColumns.value);
  }

  calculateRestEntities();
};


const calculateRestEntities = () => {
  //@ts-expect-error
  const allRecords = globalStore.gridStore.storage.allValues;
  const tmpFilterMethod = FilterService.buildFilter(TableType[TableType.disdi], true);

  let counter = 0;

  allRecords.forEach((r:any) => {
    if (tmpFilterMethod(r)) counter++;
  });

  globalStore.setCountAfterFilters(counter);
};

const setAvailableFilter = async ()=>{
  categoryList.value = await categoryService.getCategories("display", ErrorLocationType.popup); //TODO wait for selectabel API and then call it
}

onMounted(async ()=>{
  //init tmp values
  globalStore.setTmpFilters(userFilters.value.filter(f => f.tableName === TableType[TableType.disdi]));
  globalStore.setTmpHiddenColumns(userHiddenColumns.value.filter(f => f.tableName === TableType[TableType.disdi]));

  // init afterFilters count
  //@ts-expect-error
  globalStore.setCountAfterFilters(globalStore.gridStore?.count);

  await setAvailableFilter();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.disdiFilter.createDate')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('createDate') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (visibilityChange('createDate')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.disdiFilter.diaryDescription')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('diaryDescription') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (visibilityChange('diaryDescription')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.disdiFilter.comment')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('comment') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (visibilityChange('comment')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.disdiFilter.userFullname')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('userFullname') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (visibilityChange('userFullname')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.disdiFilter.userPhoneNumber')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('userPhoneNumber') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (visibilityChange('userPhoneNumber')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.disdiFilter.companyName')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('companyName') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (visibilityChange('companyName')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.disdiFilter.category')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('categoryId') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (visibilityChange('categoryId')))
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoryList.value, (category) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "inputField flex w-1/3",
                  key: category
                }, [
                  _createElementVNode("input", {
                    checked: isFiltered('categoryId', category.id),
                    type: "checkbox",
                    id: 'category' + category.id.toString(),
                    value: category.id,
                    onChange: _cache[7] || (_cache[7] = (e) => filterChanged(e, 'categoryId'))
                  }, null, 40, _hoisted_19),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", {
                      for: 'category' + category.id.toString()
                    }, [
                      _createTextVNode(_toDisplayString(category.title) + " (", 1),
                      _createElementVNode("span", {
                        class: _normalizeClass(`icon-${category?.iconName}`)
                      }, null, 2),
                      _createTextVNode(")")
                    ], 8, _hoisted_21)
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.disdiFilter.attachment')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('attachment') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (visibilityChange('attachment')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("div", _hoisted_25, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.disdiFilter.registrationStart')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('registrationStart') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[9] || (_cache[9] = ($event: any) => (visibilityChange('registrationStart')))
        }, null, 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createTextVNode(_toDisplayString(_ctx.$t('popups.disdiFilter.registrationEnd')) + " ", 1),
        _createElementVNode("span", {
          class: _normalizeClass(["colVisibilityToggle", isHidden('registrationEnd') ? 'icon-spalte-ausblenden text-red' : 'icon-spalte-anzeigen']),
          onClick: _cache[10] || (_cache[10] = ($event: any) => (visibilityChange('registrationEnd')))
        }, null, 2)
      ])
    ])
  ]))
}
}

})